import { Link } from "react-router-dom";
import styled from "styled-components";
import { DATADESC } from "../constants/app";
import { routes } from "../routes";
import { LanguageToggle } from "./LanguageToggle";
import { RoundedButton } from "./RoundedButton";
import { RoundedContainer } from "./RoundedContainer";

const FooterComponent = styled(RoundedContainer)`
    display: grid;
    grid-template-columns: 10fr 10fr 10fr 13fr;
    grid-template-rows: auto auto;
    padding: 64px;
    padding-bottom: 32px;
    color: #fff;
    line-height: 1.5;
    margin-bottom: 0;
    max-width: min(100%, calc(100vw - var(--margin-page) - var(--margin-page-right)));
    box-sizing: border-box;

    h3
    {
        font-size: var(--size-main);
        font-weight: 400;
        opacity: .5;
        margin-bottom: 1.5rem;
    }

    @media (max-width: 900px) {
        grid-template-columns: 1fr 1fr;
        padding: 40px 32px 24px;
    }

    @media (max-width: 600px) {
        grid-template-columns: 1fr;
        padding: 32px 24px 20px;

        .address {
            text-align: left !important;
        }
    }

    @media (max-width: 480px) {
        padding: 24px 16px 16px;
    }
`;

const FooterBottom = styled.div`
    margin-top: 1rem;
    grid-column: 1 / -1;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 16px;
    opacity: 1;

    div
    {
        display: flex;
        gap: 16px;
        flex-wrap: wrap;
    }

    @media (max-width: 600px) {
        flex-direction: column;
        align-items: flex-start;
    }
`;

const LogoContainer = styled.div`
    display: flex;
    gap: 16px;
    align-items: center;
    flex-wrap: wrap;
    padding: 12px 20px;
    background: rgba(255, 255, 255, 0.3);
    backdrop-filter: blur(10px);
    border-radius: 8px;
    opacity: 1;
    
    a {
        display: flex;
        align-items: center;
        transition: transform 0.2s;
        
        &:hover {
            transform: scale(1.05);
        }
    }
    
    img {
        height: 48px;
        width: auto;
        opacity: 1;
        transition: opacity 0.2s;
        filter: brightness(1.1) contrast(1.1);
        
        &:hover {
            opacity: 0.9;
        }
    }

    @media (max-width: 480px) {
        padding: 10px 14px;
        gap: 12px;
        img {
            height: 36px;
        }
    }
`;

const Footer = () => {
  return (
    <FooterComponent $background="linear-gradient(90deg, rgba(38,170,99,1) 0%, rgba(54,129,106,1) 100%);">
      <div className="features">
        <h3>Features</h3>
        <ul>
          <li>
            <Link to={routes.annotationTools.absolute}>
              Annotate with DataDesc
            </Link>
          </li>
          <li>
            <Link to="##">Calculate Data to API Compatibility</Link>
          </li>
          <li>
            <Link to="##">Integrate with Multiple Platforms</Link>
          </li>
        </ul>
      </div>
      <div className="info">
        <h3>Info</h3>
        <ul>
          <li>
            <Link to={routes.schema.absolute}>About DataDesc</Link>
          </li>
          <li>
            <a
              href="https://www.fz-juelich.de/en/ice/ice-2"
              target="_blank"
              rel="noopener noreferrer"
            >
              About ICE-2
            </a>
          </li>
          <li>
            <Link to={routes.imprint}>Contact</Link>
          </li>
          <li>
            <Link to={routes.acknowledgement}>Acknowledgement</Link>
          </li>
        </ul>
      </div>
      <div className="contact">
        <img
          src="/logo.svg"
          alt="Forschungszentrum Jülich"
          style={{
            verticalAlign: "middle",
            marginBottom: "16px",
            filter: "var(--filter-white)",
          }}
          width="64"
          height="64"
        />
        <ul>
          <li>
            <Link to={`mailto:${DATADESC.email}`}>{DATADESC.email}</Link>
          </li>
        </ul>
      </div>
      <div className="address" style={{ textAlign: "right" }}>
        <RoundedButton to="##">Register</RoundedButton>
        <ul style={{ marginTop: "24px" }}>
          <li>Forschungszentrum Jülich GmbH</li>
          <li>Institute of Climate and Energy Systems</li>
          <li>Juelich Systems Analysis (ICE-2)</li>
          <li>Wilhelm-Johnen-Straße</li>
          <li>52428 Jülich</li>
        </ul>
      </div>
      <FooterBottom>
        <LogoContainer>
          <a
            href="https://www.fz-juelich.de/en/ice/ice-2"
            target="_blank"
            rel="noopener noreferrer"
            title="Juelich Systems Analysis (ICE-2)"
          >
            <img src="/jsa_Logo.svg" alt="JSA Logo" />
          </a>
          <a
            href="https://nfdi4ing.de/"
            target="_blank"
            rel="noopener noreferrer"
            title="NFDI4ING"
          >
            <img src="/nfdi4ing_logo.svg" alt="NFDI4Ing Logo" />
          </a>
        </LogoContainer>
        <div className="footer-links">
          <Link to={routes.privacyPolicy}>Privacy Policy</Link>
          <Link to={routes.imprint}>Imprint</Link>
          <LanguageToggle />
        </div>
      </FooterBottom>
    </FooterComponent>
  );
};

export default Footer;
